import isEmail from 'validator/lib/isEmail';
import User from '../../../resources/scripts/features/user-manager';

class BrixLoginForm {
  static init(...parameters) {
    return new BrixLoginForm(...parameters);
  }

  constructor(block) {
    this.form = block.querySelector('form');
    this.emailInput = this.form.querySelector('input[type=email]');
    this.emailInputErrorMsg = this.form.querySelector('.email-field-error');
    this.passwordInput = this.form.querySelector('input[type=password]');
    this.passwordInputErrorMsg = this.form.querySelector('.password-field-error');
    this.submitButton = this.form.querySelector('.submit');
    this.generalErrorMsg = this.form.querySelector('.error-message');

    this.submitButton.addEventListener('click', (event) => {
      this.loginEventHandler(event);
    });
  }

  async loginEventHandler(event) {
    event.preventDefault();

    if (this.emailInput.value === '' || !isEmail(this.emailInput.value)) {
      this.passwordInput.parentElement.classList.remove('-error');
      this.emailInput.parentElement.classList.add('-error');
      this.generalErrorMsg.classList.remove('-visible');
      return;
    }

    if (this.passwordInput.value === '') {
      this.emailInput.parentElement.classList.remove('-error');
      this.passwordInput.parentElement.classList.add('-error');
      this.generalErrorMsg.classList.remove('-visible');
      return;
    }

    this.emailInput.parentElement.classList.remove('-error');
    this.passwordInput.parentElement.classList.remove('-error');
    this.generalErrorMsg.classList.remove('-visible');

    const response = await User.login({
      email: this.emailInput.value.toLowerCase(),
      password: this.passwordInput.value,
    });

    if (response.error) {
      this.generalErrorMsg.classList.add('-visible');
      // 19 = unknown user, 1 = wrong password
      if (response.error.code === '19' || response.error.code === '1') {
        this.generalErrorMsg.innerText = this.generalErrorMsg.dataset.wrongCredentials;
      } else {
        this.generalErrorMsg.innerText = this.generalErrorMsg.dataset.somethingWentWrong;
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-login-form', BrixLoginForm.init);
}
